import useAuth from 'src/hooks/api/useAuth';
import { useCallback, useEffect, useState } from 'react';

type OriginsReturnType = Array<{
  value: number;
  label: string;
}>;

export default () => {
  const { fetch: authFetch } = useAuth();
  const [origins, setOrigins] = useState<OriginsReturnType>([]);

  const getOrigins = useCallback(async () => {
    const queryURL = '/api/origin/{ origins{ id, labelOrigin } }';

    try {
      const resp = await authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });

      const respJson = await resp.json();

      return respJson.data.origins.map((p) => ({
        value: p.id,
        label: p.labelOrigin,
      }));
    } catch (error) {
      console.log('erreur fetch search async:\n%s', error);
      return [];
    }
  }, []);

  useEffect(() => {
    getOrigins().then(setOrigins);
  }, []);

  return origins;
};
